import { isSVGIconObject } from '@/types/elements/icon'
import type { ICardButtonProps } from './types'
import Icon from 'components/icon'

const CardButton = (props: ICardButtonProps) => {
  const { icon, title, subtitle, disabled } = props

  return (
    <button
      class={`h-full flex flex-row items-center gap-2 lg:gap-6 border p-3 lg:py-4 lg:px-5 select-none ${disabled ? 'bg-gray-200 border-gray-400 cursor-default' : 'bg-primary-100 border-primary-500 cursor-pointer hover:opacity-90'}`}
      onClick={() => props.click && props.click()}
      data-cy="card-button"
    >
      <div
        class={`w-5 h-5 lg:w-8 lg:h-8 flex align-items-center justify-center ${disabled ? 'text-gray-400' : 'text-primary-500'}`}
      >
        {icon && (isSVGIconObject(icon) ? <Icon src={icon} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} /> : <div class="w-5 h-5 lg:w-8 lg:h-8 ">{icon}</div>)}
      </div>
      <div class={`flex flex-col gap-1 	text-left`}>
        <div class={`${disabled ? 'text-gray-500' : 'text-primary-500'} text-sm font-medium lg:font-semibold`}>
          {title}
        </div>
        {subtitle &&
          <p class={`text-xs ${disabled ? 'text-gray-500' : 'text-gray-600'}`}>{subtitle}</p>
        }
      </div>
    </button>
  )
}

export default CardButton
